/* tslint:disable */
/* eslint-disable */
/**
 * Client dashboard
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationMemberDetails
 */
export interface OrganizationMemberDetails {
    /**
     * 
     * @type {string}
     * @memberof OrganizationMemberDetails
     */
    organizationId: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationMemberDetails
     */
    userMayEditLegalEntityDetails: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationMemberDetails
     */
    userMaySeeReporting: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationMemberDetails
     */
    userMaySeeFreelancerCompliance: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationMemberDetails
     */
    userMaySeeInvoicing: boolean;
}

/**
 * Check if a given object implements the OrganizationMemberDetails interface.
 */
export function instanceOfOrganizationMemberDetails(value: object): value is OrganizationMemberDetails {
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('userMayEditLegalEntityDetails' in value) || value['userMayEditLegalEntityDetails'] === undefined) return false;
    if (!('userMaySeeReporting' in value) || value['userMaySeeReporting'] === undefined) return false;
    if (!('userMaySeeFreelancerCompliance' in value) || value['userMaySeeFreelancerCompliance'] === undefined) return false;
    if (!('userMaySeeInvoicing' in value) || value['userMaySeeInvoicing'] === undefined) return false;
    return true;
}

export function OrganizationMemberDetailsFromJSON(json: any): OrganizationMemberDetails {
    return OrganizationMemberDetailsFromJSONTyped(json, false);
}

export function OrganizationMemberDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationMemberDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'organizationId': json['organizationId'],
        'userMayEditLegalEntityDetails': json['userMayEditLegalEntityDetails'],
        'userMaySeeReporting': json['userMaySeeReporting'],
        'userMaySeeFreelancerCompliance': json['userMaySeeFreelancerCompliance'],
        'userMaySeeInvoicing': json['userMaySeeInvoicing'],
    };
}

export function OrganizationMemberDetailsToJSON(value?: OrganizationMemberDetails | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'organizationId': value['organizationId'],
        'userMayEditLegalEntityDetails': value['userMayEditLegalEntityDetails'],
        'userMaySeeReporting': value['userMaySeeReporting'],
        'userMaySeeFreelancerCompliance': value['userMaySeeFreelancerCompliance'],
        'userMaySeeInvoicing': value['userMaySeeInvoicing'],
    };
}

